import React, {Component} from "react";
import classNames from "classnames";
import { CloseCircleOutlined } from '@ant-design/icons';
import css from "./MessageBox.scss";

const MessageBox = ({title, message}) => {

    const cls = classNames(
        css["message-box"],
        css["border"],
    );

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: "#F8FAFC",
                overflow: "auto",
            }}
        >
            <div className={cls}>
                <CloseCircleOutlined
                    style={{
                        color: "#F04134",
                        fontSize: "24px",
                        marginRight: "16px",
                        padding: "0 1px",
                        float: "left",
                    }} />
                <span
                    style={{
                        color: "rgba(0, 0, 0, 0.65)",
                        fontWeight: "bold",
                        fontSize: "14px",
                    }}
                >
                    {title}
                </span>
                <div
                    style={{
                        marginLeft: "42px",
                        fontSize: "12px",
                        color: "rgba(0, 0, 0, 0.65)",
                        marginTop: "8px",
                    }}
                >
                    {message}
                </div>
            </div>
        </div>
    );
};


export default MessageBox;
